
import { Button, ButtonBase } from '@mui/material';
import { React, useContext, useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { Typeahead, TypeaheadMenu } from 'react-bootstrap-typeahead';
import Form from 'react-bootstrap/Form';

import Modal from 'react-bootstrap/Modal';
import { useAuth } from 'react-oidc-context';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { SnackbarContext } from '../../../App';
import ConfirmDeleteModal from '../../../utils/manageClient/ConfirmDeleteModal';
import AccessControl from '../../../utils/manageClient/AccessControl';
import ClientNameUpdate from '../../../utils/manageClient/ClientNameUpdate';
import AccountingSoftwareUpdate from '../../../utils/manageClient/AccountingSoftwareUpdate';

export default ({ show, onClose, clientId, onDeleteConfirm, onRefresh, customerData, serCurrentClientDetail, userData }) => {
  const auth = useAuth();

  const [
    abn,
    setABN,
  ] = useState('');

  const [
    clientid,
    setCLientId,
  ] = useState(-1);

  const [
    clientName,
    setClientName,
  ] = useState('');

  const [
    financialSWAccount,
    setFinancialSWAccount,
  ] = useState('');

  const [
    financialSWType,
    setFinancialSWType,
  ] = useState('XERO');

  const [
    contactName,
    setContactName,
  ] = useState();

  const [
    contactEmail,
    setContactEmail,
  ] = useState();

  const [
    autoForwarding,
    setAutoForwarding,
  ] = useState(false);

  const [
    adminEmails,
    setAdminEmails,
  ] = useState([]);

  const [
    selectedUsers,
    setSelectedUsers,
  ] = useState([]);

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    deleteModalShow,
    setDeleteModalShow,
  ] = useState(false);

  const [
    updateNameModalShow,
    setUpdateNameModalShow,
  ] = useState(false);

  const [
    updateContactNameModalShow,
    setUpdateContactNameModalShow,
  ] = useState(false);

  const [
    updateContactEmailModalShow,
    setUpdateContactEmailModalShow,
  ] = useState(false);

  const [
    updateAutoForwardingModalShow,
    setUpdateAutoForwardingModalShow,
  ] = useState(false);

  const [
    updateAccountingSoftwareModalShow,
    setUpdateAccountingSoftwareModalShow,
  ] = useState(false);

  const [
    updateAccessShow,
    setUpdateAccessShow,
  ] = useState(false);

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  function deleteClient() {
    if (clientid != -1) {
      fetch(`${window.origin}/api/client/${clientid}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      }).then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
        } else {
          setSnackBarMessage('Client has been deleted');
          setSnackBarShow(true);
          setDeleteModalShow(false);
          onClose();
          serCurrentClientDetail(null);
          onRefresh();
        }
      },
      );
    }
  }

  useEffect(() => {
    console.log('changed');

    if (clientId) {
      let client = customerData.find(item => item.id == clientId);
      try {
        console.log(client);
        setCLientId(client.id);
        console.log(client.id);
        setABN(client.ABN);
        setClientName(client.clientName);

        setContactName(client.contactName);
        setContactEmail(client.contactEmail);

        setFinancialSWAccount(client.financialSWAccount);
        setFinancialSWType(client.financialSWType.toUpperCase());
        setSelectedUsers(client.users);
        setAutoForwarding(client.autoForwarding);
        console.log(client.autoForwarding);
      } catch (e) {

      }
    } else {
      setTimeout(() => {
        setCLientId(-1);
        setABN('');
        setClientName('');
        setFinancialSWAccount('');
        setFinancialSWType('XERO');

        setContactName('');
        setContactEmail('');
        setSelectedUsers([]);
        setAutoForwarding(false);
      }, 200);
    }
  }, [
    clientId,
    customerData,
  ]);

  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        dialogClassName="modal-50w"
        aria-labelledby="example-custom-modal-styling-title"
      >

        <Modal.Body style={{ padding: '2vw 3vw', paddingBottom: '0vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.7)' }}>

          <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '2vw', fontWeight: '500' }}>{clientName}</h4>

          {/* <p style={{margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(255, 255, 255, 0.7)'}}>Please provide details of the user you want to invite.</p> */}

          <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Details</p>
          <div style={{ margin: '0.5vw 0vw 2vw 0vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', borderRadius: '1vw', overflow: 'hidden' }}>
            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderTopLeftRadius: '1vw', borderTopRightRadius: '1vw', marginTop: '0', marginBottom: '0' }}>
              <div style={{ fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Client ABN</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>{abn}</p>
              </div>
            </div>
            <ButtonBase disabled={!auth.user?.profile.groups.includes('client-admin')} onClick={() => setUpdateNameModalShow(true)} style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderRadius: '0', marginTop: '0', marginBottom: '0', width: '100%' }}>
              <div style={{ fontWeight: '500', fontSize: '0.8vw', marginRight: '2vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Client Name</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>{clientName}</p>
              </div>
            </ButtonBase>
            <ButtonBase disabled={!auth.user?.profile.groups.includes('client-admin')} onClick={() => setUpdateAccountingSoftwareModalShow(true)} style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderRadius: '0', marginTop: '0', marginBottom: '0', width: '100%' }}>
              <div style={{ flex: 1, fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Accounting Software</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>{financialSWType}</p>
              </div>
            </ButtonBase>

          </div>

          {auth.user?.profile.groups.includes('client-admin') && (
            <>
              <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Access</p>
              <div style={{ margin: '0.5vw 0vw 2vw 0vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', borderRadius: '1vw', overflow: 'hidden' }}>
                <ButtonBase onClick={() => { setUpdateAccessShow(true); }} style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderTopLeftRadius: '1vw', borderTopRightRadius: '1vw', marginTop: '0', marginBottom: '0', width: '100%' }}>
                  <div style={{ fontWeight: '500', fontSize: '0.8vw' }}>
                    <p style={{ margin: 0, textAlign: 'left' }}>Assigned to</p>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ textAlign: 'right' }}>
                      { selectedUsers.length > 0 && selectedUsers.map(item => <img width="1.5vw" src={`https://ui-avatars.com/api/?name=${item.firstName}+${item.lastName}`} style={{ width: '1.5vw', borderRadius: '50%' }} alt="User avatar" />)}
                      { selectedUsers.length == 0 && <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>None</p>}
                    </div>
                  </div>
                </ButtonBase>
                <ButtonBase onClick={() => { setDeleteModalShow(true); }} style={{ width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.25vw', fontSize: '0.8vw', color: 'red' }}>
                  <div style={{ flex: 1, fontWeight: '500', textAlign: 'left' }}>
                    <p style={{ margin: 0 }}>Delete Client</p>
                  </div>
                  <div style={{ flex: 1, textAlign: 'right' }}>
                    <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
                  </div>
                </ButtonBase>

              </div>
            </>
          )}
          <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>

            <Button
              onClick={onClose}
              variant="outlined"
              style={{
                borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1.5vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                width: '100%', marginTop: '1vw' }}
            >
              Close
            </Button>
          </Form.Group>

        </Modal.Body>
      </Modal>

      <ConfirmDeleteModal show={deleteModalShow} onClose={setDeleteModalShow} onDelete={deleteClient} />

      <ClientNameUpdate show={updateNameModalShow} onClose={setUpdateNameModalShow} onRefresh={onRefresh} clientId={clientid} initialClientName={clientName} />

      <AccountingSoftwareUpdate show={updateAccountingSoftwareModalShow} onClose={setUpdateAccountingSoftwareModalShow} onRefresh={onRefresh} clientId={clientid} initialAccountingSoftware={financialSWType} />

      <AccessControl show={updateAccessShow} onClose={setUpdateAccessShow} clientId={clientid} initialSelectedUsers={selectedUsers} users={userData} onRefresh={onRefresh} />

    </>

  );
};
